import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

type LeaseDetailsSubmitLockValue = {
  locked: boolean;
  setLocked: (locked: boolean) => void;
};

const LeaseDetailsSubmitLockContext = createContext<LeaseDetailsSubmitLockValue>({
  locked: false,
  setLocked: () => {},
});

/**
 * Lets a form slot disable the engine submit button without `disableWhenInvalid`.
 * Defaults to unlocked, so surfaces that never set it keep today's button behavior.
 */
export function LeaseDetailsSubmitLockProvider({ children }: { children: ReactNode }) {
  const [locked, setLocked] = useState(false);
  const value = useMemo(() => ({ locked, setLocked }), [locked]);

  return (
    <LeaseDetailsSubmitLockContext.Provider value={value}>
      {children}
    </LeaseDetailsSubmitLockContext.Provider>
  );
}

export const useLeaseDetailsSubmitLocked = (): boolean =>
  useContext(LeaseDetailsSubmitLockContext).locked;

export const useSetLeaseDetailsSubmitLock = (): LeaseDetailsSubmitLockValue['setLocked'] =>
  useContext(LeaseDetailsSubmitLockContext).setLocked;
